<template>
  <div class="maxbox">
    <div>
      <div class="top">
        <p>管理员后台管理</p>
      </div>
      <div class="main">
        <button class="return" @click="goback">
          <img src="@/assets/images/left-arrow.png" alt="">
        </button>

        <!-- 功能切换 -->
        <div style="margin-top: 20px; display: flex; gap: 15px;">
          <button :class="{active: tabType === 'editRef'}" @click="tabType='editRef'">修改用户上级</button>
          <button :class="{active: tabType === 'exportData'}" @click="tabType='exportData'">导出合约全部数据</button>
          <button :class="{active: tabType === 'teamQuery'}" @click="tabType='teamQuery'">团队关系查询</button>
        </div>

        <!-- 修改推荐关系区域 -->
        <div v-if="tabType === 'editRef'" style="margin-top:20px;">
          <div style="margin:10px 0;">
            <label>目标用户地址：</label>
            <input v-model="editForm.userAddr" placeholder="填写要修改的用户钱包地址" style="width:380px;padding:4px 6px;">
          </div>
          <div style="margin:10px 0;">
            <label>新上级地址：</label>
            <input v-model="editForm.newRefAddr" placeholder="填0x0清空上级" style="width:380px;padding:4px 6px;">
          </div>
          <p style="color:#f56c6c;font-size:13px;margin:8px 0;">提示：用户存在直推下级，无法修改推荐关系</p>
          <button @click="changeUserRefer" style="margin-top:10px;padding:5px 15px;background:#1989fa;color:#fff;border:none;border-radius:4px;">
            确认修改推荐关系
          </button>
        </div>

        <!-- 导出合约数据区域 -->
        <div v-if="tabType === 'exportData'" style="margin-top:20px;">
          <div style="margin:10px 0;">
            <label>分页起始下标：</label>
            <input type="number" v-model.number="exportParam.start" min="0" style="width:120px;padding:4px 6px;">
            <label style="margin-left:15px;">单次读取条数：</label>
            <input type="number" v-model.number="exportParam.size" min="1" max="200" style="width:120px;padding:4px 6px;">
          </div>
          <div style="margin:10px 0;">
            <label>保留最新记录条数：</label>
            <input type="number" v-model.number="exportParam.keepNum" min="1" style="width:120px;padding:4px 6px;">
            <button @click="cleanOldRecord" style="margin-left:15px;padding:4px 12px;background:#e6a23c;color:#fff;border:none;border-radius:4px;">
              批量清理旧结算记录
            </button>
          </div>
          <div style="margin-top:15px;">
            <button @click="readBatchMember" style="padding:5px 15px;background:#67c23a;color:#fff;border:none;border-radius:4px;">
              读取分页会员数据
            </button>
            <button @click="downloadAllData" style="margin-left:10px;padding:5px 15px;background:#1989fa;color:#fff;border:none;border-radius:4px;">
              导出全部数据JSON
            </button>
          </div>

          <div style="margin-top:20px;">
            <p>合约总用户数：{{totalMemberCount}}</p>
            <p>当前读取数据条数：{{memberDataList.length}}</p>
            <p>操作状态：{{operateStatus}}</p>
          </div>
        </div>

        <!-- 团队关系查询区域 -->
        <div v-if="tabType === 'teamQuery'" style="margin-top:20px;">
          <div style="margin:10px 0;">
            <label>查询用户地址：</label>
            <input v-model="queryAddr" placeholder="输入需要查询的用户钱包地址" style="width:380px;padding:4px 6px;">
          </div>
          <div style="margin:15px 0;display:flex;gap:15px;">
            <button @click="getUserDirectSub" style="padding:5px 15px;background:#409eff;color:#fff;border:none;border-radius:4px;">
              查看直推下级列表
            </button>
            <button @click="getUserUpChain" style="padding:5px 15px;background:#67c23a;color:#fff;border:none;border-radius:4px;">
              查看上级推荐链路
            </button>
          </div>
          <div style="margin-top:15px;">
            <p style="font-weight:bold;">查询结果：</p>
            <textarea v-model="queryResult" readonly style="width:500px;height:220px;padding:6px;"></textarea>
          </div>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import { ethers } from 'ethers'
import { contractAddress, contractABI } from '@/js/contract.js'

const TOKEN_DECIMAL = 1000000

export default {
  data() {
    return {
      contract: null,
      signer: null,
      tabType: 'editRef',
      operateStatus: '空闲',
      totalMemberCount: 0,
      editForm: {
        userAddr: '',
        newRefAddr: ''
      },
      exportParam: {
        start: 0,
        size: 50,
        keepNum: 20
      },
      memberDataList: [],
      queryAddr: '',
      queryResult: ''
    }
  },
  mounted() {
    this.initConnect()
  },
  methods: {
    goback() {
      this.$router.go(-1)
    },
    async initConnect() {
      if (!window.ethereum) return alert("请安装MetaMask钱包")
      const provider = new ethers.providers.Web3Provider(window.ethereum)
      await provider.send("eth_requestAccounts", [])
      this.signer = provider.getSigner()
      this.contract = new ethers.Contract(contractAddress, contractABI, this.signer)
      await this.getTotalMemberNum()
    },
    async getTotalMemberNum() {
      try {
        this.totalMemberCount = Number(await this.contract.getTotalMemberCount())
      } catch (e) {
        console.log("读取总用户数失败", e)
      }
    },
    async changeUserRefer() {
      if (!this.editForm.userAddr) return alert("请输入目标用户地址")
      this.operateStatus = "执行修改中"
      try {
        let newAddr = this.editForm.newRefAddr || ethers.constants.AddressZero
        const tx = await this.contract.editUserReferrer(this.editForm.userAddr, newAddr)
        await tx.wait()
        alert("用户推荐关系修改成功！")
        this.editForm.userAddr = ''
        this.editForm.newRefAddr = ''
      } catch (err) {
        console.error(err)
        let msg = err?.error?.message || err.message || "修改失败"
        if (msg.includes("has direct subordinates")) {
          msg = "失败：该用户存在直推下级，禁止迁移上级"
        }
        alert(msg)
      }
      this.operateStatus = "空闲"
    },
    async readBatchMember() {
      this.operateStatus = "读取数据中"
      try {
        const { users, refs, withdraws } = await this.contract.getBatchMemberSimple(
          this.exportParam.start,
          this.exportParam.size
        )
        let list = []
        for (let i = 0; i < users.length; i++) {
          list.push({
            userAddress: users[i],
            referrerAddress: refs[i],
            withdrawBalance: ethers.utils.formatUnits(withdraws[i], 6)
          })
        }
        this.memberDataList = list
        alert(`成功读取${list.length}条会员数据`)
      } catch (e) {
        alert("读取分页数据失败")
        console.log(e)
      }
      this.operateStatus = "空闲"
    },
    async cleanOldRecord() {
      if(this.exportParam.keepNum < 1){
        return alert("保留记录条数必须大于0")
      }
      this.operateStatus = "清理数据中"
      try {
        const tx = await this.contract.batchDelUserRecordByPage(
          this.exportParam.start,
          this.exportParam.size,
          this.exportParam.keepNum
        )
        await tx.wait()
        alert(`批量清理成功！\n起始下标：${this.exportParam.start}\n处理用户数量：${this.exportParam.size}\n每位用户仅保留最新${this.exportParam.keepNum}条分红记录`)
      } catch (e) {
        console.error(e)
        let errMsg = e?.error?.message || e.message || "清理失败"
        alert("清理失败：" + errMsg)
      }
      this.operateStatus = "空闲"
    },
    downloadAllData() {
      if (this.memberDataList.length <= 0) return alert("请先读取会员数据")
      let jsonStr = JSON.stringify(this.memberDataList, null, 2)
      let blob = new Blob([jsonStr], { type: "application/json" })
      let url = URL.createObjectURL(blob)
      let a = document.createElement("a")
      a.href = url
      a.download = `合约会员数据_${new Date().getTime()}.json`
      document.body.appendChild(a)
      a.click()
      document.body.removeChild(a)
      URL.revokeObjectURL(url)
    },
    async getUserDirectSub() {
      if (!this.queryAddr) return alert("请输入查询用户地址")
      this.queryResult = "正在读取数据..."
      try {
        let subs = await this.contract.getTargetUserDirectReferrals(this.queryAddr)
        if (!subs || subs.length === 0) {
          this.queryResult = `用户：${this.queryAddr}\n暂无任何直推下级`
          return
        }
        let str = `用户地址：${this.queryAddr}\n直推下级总数：${subs.length}\n\n下级列表：\n`
        subs.forEach((item, idx) => {
          str += `${idx+1}. ${item}\n`
        })
        this.queryResult = str
      } catch (err) {
        this.queryResult = "查询直推下级失败：" + (err.message || err)
      }
    },
    async getUserUpChain() {
      if (!this.queryAddr) return alert("请输入查询用户地址")
      this.queryResult = "正在读取上级链路..."
      try {
        let chainList = await this.contract.getUserReferChain(this.queryAddr)
        if (!chainList || chainList.length === 0) {
          this.queryResult = `用户：${this.queryAddr}\n无上级，为顶级账号`
          return
        }
        let str = `用户地址：${this.queryAddr}\n上级链路层级总数：${chainList.length}\n\n从上至下上级顺序：\n`
        chainList.forEach((addr, index) => {
          str += `第${index+1}级上级：${addr}\n`
        })
        this.queryResult = str
      } catch (err) {
        this.queryResult = "查询上级推荐链失败：" + (err.message || err)
      }
    }
  }
}
</script>

<style scoped>
.main{padding-top:40px;}
button.active{
  background: #1989fa;
  color: #fff;
  border: none;
  padding: 4px 12px;
  border-radius: 4px;
}
button:not(.active){
  background: #f5f5f5;
  border: 1px solid #ccc;
  padding: 4px 12px;
  border-radius: 4px;
}
</style>